export default "__VITE_ASSET__IsFvLWn8__"